<template>
  <DpplSvg :file-name="atsFilePath" class="article-ats-image" />
</template>

<script setup>
import { computed } from 'vue';
import {
  SMARTRECRUITERS, GREENHOUSE, GR8PEOPLE, LEVER, WORKDAY, SUCCESSFACTORS, ICIMS,
} from '@/helpers/constants/atsIds';
import { useAppAuthData } from '@/stores/app/authData';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { storeToRefs } from 'pinia';

const props = defineProps({
  fileName: {
    type: String,
    required: true,
  },
});

const { authData } = storeToRefs(useAppAuthData());

const atsIds = {
  [GREENHOUSE]: 'greenhouse',
  [SMARTRECRUITERS]: 'smartrecruiters',
  [GR8PEOPLE]: 'gr8people',
  [LEVER]: 'lever',
  [WORKDAY]: 'workday',
  [SUCCESSFACTORS]: 'successfactors',
  [ICIMS]: 'icims',
};

const atsToUse = computed(() => atsIds[authData.value?.atsId]);

const atsFilePath = computed(() => `ats/${atsToUse.value}-${props.fileName}`);
</script>

<style lang="less" scoped>
.article-ats-image {
  border-radius: 8px 8px 0 0;
}
</style>
